import Script from 'next/script';
import { BuilderComponentProps } from '../../builder';
import { SectionName } from '../../observability';
import { InViewTracking } from '../InViewTracking/InViewTracking';

type Props = {
  dataSource?: string;
} & BuilderComponentProps;
export function HubSpotMeeting({ dataSource, ...rest }: Props) {
  if (!dataSource) return null;
  return (
    <InViewTracking
      sectionName={SectionName.HubSpotMeeting}
      layerName={rest?.builderBlock?.layerName}
    >
      <div className="meetings-iframe-container" data-src={dataSource}></div>
      <Script
        type="text/javascript"
        src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
      />
    </InViewTracking>
  );
}
